import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { useKeyboardListener } from '../../utils';
const IconHOC = (IconComponent) => (props) => {
    const svgRef = useRef(null);
    const onKeyDownHandler = (event) => {
        props.onClick && props.onClick(event);
    };
    useKeyboardListener(svgRef, {
        Enter: onKeyDownHandler,
        ' ': onKeyDownHandler,
    });
    const commonAttributes = {
        ref: svgRef,
        width: props.width || '2.5vmin',
        height: props.height || '2.5vmin',
        tabIndex: 0,
        xmlns: 'http://www.w3.org/2000/svg',
        style: Object.assign({}, props.styles),
        onClick: props.onClick,
    };
    return _jsx(IconComponent, Object.assign({}, props, { commonAttributes: Object.assign({}, commonAttributes) }));
};
export default IconHOC;
